<template>
  <div id="sub">
 
    <!-- ======================== 히어로 캐러셀 ======================== -->
    <section class="sub-main">
      <div id="carouselSubIndicators" class="carousel slide" data-bs-ride="carousel" data-bs-touch="true" data-bs-interval="3000">
        <div class="carousel-indicators">
          <button type="button" data-bs-target="#carouselSubIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselSubIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselSubIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
          <button type="button" data-bs-target="#carouselSubIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
          <button type="button" data-bs-target="#carouselSubIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
          <button type="button" data-bs-target="#carouselSubIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="../assets/img/bustour/kyoto.jpg" class="d-block w-100 hero-img" alt="교토" v-if="this.mobileDisplay || this.isApp">
            <img src="../assets/img/bustour/kyoto.jpg" class="d-block w-100 hero-img hero-img-pc" alt="교토" v-else>
            <div class="carousel-caption hero-caption">
              <div class="caption-inner">
                <span class="caption-tag">KYOTO · 교토</span>
                <h5>일본의 과거와 현재가 공존하는, 교토</h5>
                <p>일본의 역사가 잔뜩 담긴 교토 버스투어</p>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <img src="../assets/img/bustour/bus_biei.jpg" class="d-block w-100 hero-img" alt="비에이" v-if="this.mobileDisplay || this.isApp">
            <img src="../assets/img/bustour/bus_biei.jpg" class="d-block w-100 hero-img hero-img-pc" alt="비에이" v-else>
            <div class="carousel-caption hero-caption">
              <div class="caption-inner">
                <span class="caption-tag">BIEI · 비에이</span>
                <h5>대자연의 아름다움, 북해도 비에이</h5>
                <p>형형색색의 꽃들의 물결과 푸른 연못 등 자연 만끽!</p>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <img src="../assets/img/bustour/bus_nagoya.jpg" class="d-block w-100 hero-img" alt="나고야시라카와고" v-if="this.mobileDisplay || this.isApp">
            <img src="../assets/img/bustour/bus_nagoya.jpg" class="d-block w-100 hero-img hero-img-pc" alt="비에이" v-else>
            <div class="carousel-caption hero-caption">
              <div class="caption-inner">
                <span class="caption-tag">SHIRAKAWAGO · 시라카와고</span>
                <h5>중세일본 문화탐방, 다카야마 시라카와고</h5>
                <p>세계문화유산과 에도시대의 거리를 만끽할 수 있는 절호의 기회</p>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <img src="../assets/img/bustour/bus_kamakura.jpg" class="d-block w-100 hero-img" alt="가마쿠라" v-if="this.mobileDisplay || this.isApp">
            <img src="../assets/img/bustour/bus_kamakura.jpg" class="d-block w-100 hero-img hero-img-pc" alt="비에이" v-else>
            <div class="carousel-caption hero-caption">
              <div class="caption-inner">
                <span class="caption-tag">KAMAKURA · 가마쿠라</span>
                <h5>각종 미디어 작품의 배경 도시 가마쿠라</h5>
                <p>도쿄 근교 대표 바닷가로 떠나자!</p>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <img src="../assets/img/main/yamaguchi_brl.jpg" class="d-block w-100 hero-img" alt="야마구치" v-if="this.mobileDisplay || this.isApp">
            <img src="../assets/img/main/yamaguchi_brl.jpg" class="d-block w-100 hero-img hero-img-pc" alt="야마구치" v-else>
            <div class="carousel-caption hero-caption">
              <div class="caption-inner">
                <span class="caption-tag">YAMAGUCHI · 야마구치</span>
                <h5>기타큐슈 출발, 아름다움의 대명사 야마구치</h5>
                <p>부관훼리 맞춤 시모노세키항 경유</p>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <img src="../assets/img/main/kavalan.jpg" class="d-block w-100 hero-img" alt="카발란" v-if="this.mobileDisplay || this.isApp">
            <img src="../assets/img/main/kavalan.jpg" class="d-block w-100 hero-img hero-img-pc" alt="카발란" v-else>
            <div class="carousel-caption hero-caption">
              <div class="caption-inner">
                <span class="caption-tag">KAVALAN · 카발란</span>
                <h5>위스키향 가득 카발란, 자오시 온천</h5>
                <p>따뜻한 온천과 위스키 제조와 시음까지 해 볼 수 있는 기회!</p>
              </div>
            </div>
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselSubIndicators" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselSubIndicators" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </section>
 
 
    <!-- ======================== 일본 현지투어 ======================== -->
    <section id="pack" class="packages">
      <div class="container">
        <div class="packages-content">
          <div class="row gx-4">
 
            <!-- 섹션 제목 -->
            <div class="sub-title" id="world-jp">
              <div class="title-accent-line"></div>
              <span class="st-main">일본 현지투어</span>
              <span class="st-sub">일본에서 최고의 하루를 드립니다.</span>
            </div>
 
            <!-- 카테고리 필터 -->
            <div class="category">
              <ul :key="ntCd" v-for="(jp, ntCd) in this.ntToAr_jp">
                <li key="jpAll" class="fingerPointer" @click="showJpSelArea('jpAll')">
                  <a href="javascript: void(0)">전체</a>
                </li>
                <li :key="ar.arCd" v-for="ar in jp" @click="showJpSelArea(ar.arCd)">
                  <a href="javascript: void(0)">{{ ar.AR }}</a>
                </li>
              </ul>
            </div>
 
            <!-- 상품 카드 (★ col-lg-6 → col-lg-4 : 1라인 3개) -->
            <div class="col-lg-4 col-md-6 col-sm-12 mb-5" :key="i" v-for="(nd, i) in this.ndaytirpList_jp">
              <div class="text-decoration-none link-dark">
                <div class="package-item">
                  <div class="pic" @click="goToDetail(nd.pdtCode, nd.salesRoute)" style="cursor: pointer">
                    <div class="packages-hover">
                      <div class="packages-hover-content">
                        <span class="hover-cta">자세히 보기 <i class="bi bi-arrow-right"></i></span>
                      </div>
                    </div>
                    <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="card-img-top" alt="..." />
                    <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img-top" />
                    <div class="badge">
                      <div v-if="nd.badgeFlag === 'Y'">
                        <div class="badge1"><small class="badge1-text">{{ nd.badge }}</small></div>
                      </div>
                      <div v-if="nd.badge2Flag === 'Y'">
                        <div v-if="nd.badgeFlag != 'Y'" class="badge1"><small class="badge1-text">{{ nd.badge2 }}</small></div>
                        <div v-else class="badge2" style="margin-left: 180px;"><small class="badge2-text">{{ nd.badge2 }}</small></div>
                      </div>
                    </div>
                  </div>
                  <div class="package-item-txt">
                    <div class="pdtName">{{ nd.pdtNameKor }}</div>
                    <div class="pdtRemarks">
                      <i class="bi bi-bus-front-fill"></i> {{ nd.pdtRemarks }}
                    </div>
                    <div class="card-divider"></div>
                    <div class="price">
                      <div class="priceSection">
                        <div>
                          <!-- 가격 표시 -->
                          <div class="my-1 d-flex align-items-center flex-wrap price-row"
                               v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'"
                               @click="goToDetail(nd.pdtCode, nd.salesRoute)" style="cursor: pointer;">
                            <b class="fs-4 fw-bolder ndayPrice" v-if="nd.discountPercent == 0">
                              {{ getCurrencyFormat(nd.pdtPrice) }} <span class="price-won">원</span>
                            </b>
                            <template v-else>
                              <b class="text-muted text-decoration-line-through me-2 ndayPrice original-price">
                                {{ getCurrencyFormat(nd.pdtPrice) }}원
                              </b>
                              <i class="bi bi-caret-right-fill text-muted" style="font-size:.8rem"></i>
                              <span class="mx-2 ndayPrice discount-rate">
                                {{ getCurrencyFormat(nd.discountPercent) }}%
                              </span>
                              <span class="ndayPrice fs-4 fw-bolder final-price">
                                {{ getCurrencyFormat((nd.basic_PdtPrice * 1) + (nd.minOptPrice * 1)) }}
                              </span>
                              <span class="price-won"> 원~</span>
                            </template>
                          </div>
                          <!-- 준비중 -->
                          <div class="my-1 d-flex align-items-center preparing-wrap" v-else>
                            <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                            <span class="ndayPrice preparing-text">상품을 준비 중입니다</span>
                            <i class="bi bi-question-circle-fill text-danger"
                               style="cursor: pointer; padding-left: 5px; font-size:.9rem"
                               data-bs-toggle="tooltip" data-bs-placement="top"
                               title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요"
                               @click="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
            <!-- 더보기 (일본) -->
            <div class="more-wrap more-jp justify-content-center fingerPointer" @click="showJpMoreList()" v-if="this.ndaytirpList_jp_more.length > 0">
              <div class="more-btn" v-if="this.jp_more === 'N'">
                <span>더보기</span> <i class="bi bi-chevron-down"></i>
              </div>
              <div class="more-btn" v-else>
                <span>접기</span> <i class="bi bi-chevron-up"></i>
              </div>
            </div>
            <div class="more-wrap more-jp" v-else></div>
 
          </div>
        </div>
      </div>
    </section>
 
 
    <!-- ======================== 나라별 현지투어 ======================== -->
    <section id="pack-etc" class="packages packages-etc">
      <div class="container">
        <div class="packages-content">
          <div class="row gx-4">
 
            <!-- 섹션 제목 -->
            <div class="sub-title" id="world-etc">
              <div class="title-accent-line"></div>
              <span class="st-main">나라별 현지투어</span>
              <span class="st-sub">다양한 나라에서 최고의 하루를 드립니다.</span>
            </div>
 
            <!-- 카테고리 필터 -->
            <div class="category">
              <ul>
                <li key="etcAll" @click="showEtcSelArea('etcAll')"><a href="javascript: void(0)">전체</a></li>
                <li :key="ntCd" v-for="(etc, ntCd) in this.ntToAr_etc" @click="showEtcSelArea(etc[0].ntCd)">
                  <a href="javascript: void(0)">{{ etc[0].NT }}</a>
                </li>
              </ul>
            </div>
 
            <!-- 상품 카드 -->
            <div class="col-lg-4 col-md-6 col-sm-12 mb-5" :key="j" v-for="(nd, j) in this.ndaytirpList_etc">
              <div class="text-decoration-none link-dark">
                <div class="package-item">
                  <div class="pic" @click="goToDetail(nd.pdtCode, nd.salesRoute)" style="cursor: pointer">
                    <div class="packages-hover">
                      <div class="packages-hover-content">
                        <span class="hover-cta">자세히 보기 <i class="bi bi-arrow-right"></i></span>
                      </div>
                    </div>
                    <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="card-img-top" alt="..." />
                    <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img-top" />
                    <div class="badge">
                      <div v-if="nd.badgeFlag === 'Y'">
                        <div class="badge1"><small class="badge1-text">{{ nd.badge }}</small></div>
                      </div>
                      <div v-if="nd.badge2Flag === 'Y'">
                        <div v-if="nd.badgeFlag != 'Y'" class="badge1"><small class="badge1-text">{{ nd.badge2 }}</small></div>
                        <div v-else class="badge2" style="margin-left: 180px;"><small class="badge2-text">{{ nd.badge2 }}</small></div>
                      </div>
                    </div>
                  </div>
                  <div class="package-item-txt">
                    <div class="pdtName">{{ nd.pdtNameKor }}</div>
                    <div class="pdtRemarks">
                      <i class="bi bi-bus-front-fill"></i> {{ nd.pdtRemarks }}
                    </div>
                    <div class="card-divider"></div>
                    <div class="price">
                      <div class="priceSection">
                        <div>
                          <div class="my-1 d-flex align-items-center flex-wrap price-row"
                               v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'"
                               @click="goToDetail(nd.pdtCode, nd.salesRoute)" style="cursor: pointer;">
                            <b class="fs-4 fw-bolder ndayPrice" v-if="nd.discountPercent == 0">
                              {{ getCurrencyFormat(nd.pdtPrice) }} <span class="price-won">원</span>
                            </b>
                            <template v-else>
                              <b class="text-muted text-decoration-line-through me-2 ndayPrice original-price">
                                {{ getCurrencyFormat(nd.pdtPrice) }}원
                              </b>
                              <i class="bi bi-caret-right-fill text-muted" style="font-size:.8rem"></i>
                              <span class="mx-2 ndayPrice discount-rate">
                                {{ getCurrencyFormat(nd.discountPercent) }}%
                              </span>
                              <span class="ndayPrice fs-4 fw-bolder final-price">
                                {{ getCurrencyFormat((nd.basic_PdtPrice * 1) + (nd.minOptPrice * 1)) }}
                              </span>
                              <span class="price-won"> 원~</span>
                            </template>
                          </div>
                          <div class="my-1 d-flex align-items-center preparing-wrap" v-else>
                            <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                            <span class="ndayPrice preparing-text">상품을 준비 중입니다</span>
                            <i class="bi bi-question-circle-fill text-danger"
                               style="cursor: pointer; padding-left: 5px; font-size:.9rem"
                               data-bs-toggle="tooltip" data-bs-placement="top"
                               title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요"
                               @click="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
            <!-- 더보기 (나라별) -->
            <div class="more-wrap more-etc justify-content-center fingerPointer" @click="showEtcMoreList()" v-if="this.ndaytirpList_etc_more.length > 0">
              <div class="more-btn" v-if="this.etc_more === 'N'">
                <span>더보기</span> <i class="bi bi-chevron-down"></i>
              </div>
              <div class="more-btn" v-else>
                <span>접기</span> <i class="bi bi-chevron-up"></i>
              </div>
            </div>
 
          </div>
        </div>
      </div>
    </section>
 
  </div>
</template>

<script>
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      // ntToAr: {},                   //버스투어가능국가지역
      // ntToAr_etc: {},               //버스투어가능국가지역
      ntToAr_jp: [],                    //일본내 버스투어가능지역
      ntToAr_etc: [],                   //버스투어가능 국가와 지역
      nt: "",                           //상품카테고리(국가기준)
      ar: "",                           //상품카테고리(지역기준)

      sellerCode: "ND",                 //판매자코드(엔데이트립)

      productListForSales_org: [],      //로컬전체상품
      productListForSales: [],          //판매상품리스트
      ndaytirpList_jp: [],              //일본내 상품
      ndaytirpList_jp_org: [],
      ndaytirpList_jp_more: [],
      ndaytirpList_etc: [],             //일본외 상품
      ndaytirpList_etc_org: [],
      ndaytirpList_etc_more: [],
      jp_more: "N",                     //일본내 더보기
      etc_more: "N",                    //일본외 더보기

      //showLayer: false,               //지역(국가)선택레이어

      natName: "",                      //표시페이지 국가명
      selectableNation: [],             //선택가능 국가
      nationList: {},                   //여행지역리스트
      pdtCatList: {},                   //상품카테고리
      
      productListForSales_recomend: {}, //추천상품리스트
    };
  },
  created() {
    // 유저디바이스체크 (모바일처리용)
    if (this.$isMobile()) 
    {
      this.mobileDisplay = true;
    } 
    else 
    {
      this.mobileDisplay = false;
    }
    //console.log("mobileDisplay:", this.mobileDisplay);
    
    // 페이지생성과 동시에 리스트정보를 get
		this.nt = (this.$route.query.nt == undefined) ? "%" : this.$route.query.nt;
    this.ar = (this.$route.query.ar == undefined) ? "%" : this.$route.query.ar;
		this.sellerCode = (this.$route.query.sc === undefined) ? "ND" : this.$route.query.sc;

    this.getProductList_new()

    //this.getProductList();
    this.getNationList();
    this.getBustourArea();
  },
  mounted() {
    // if(document.referrer == "") {
    //   this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
    //   //this.$router.push({path: '/'});
    //   location.replace("/");
    // }

    //this.scrollToSection();
    // 구동환경 체크
    if (window.Nachocode.env.isApp()) 
    {
      this.isApp = true;
      //console.log('isApp:', this.isApp);
    }
    else 
    {
      this.isApp = false;
      //console.log('isApp:', this.isApp);
    }
  },
  computed: {
    user() {
      // 리턴정보가 바뀔 때마다 user()안에 넣어준다
      // 로그인전: bId정보없음, 로그인후: bId정보있음
      return this.$store.state.user;
    }
  },  
  methods: {
    scrollToSection(param) {
      const elementId = (param === 'JP') ? 'world-jp' : 'world-etc';
      const element = document.getElementById(elementId);

      //console.log(document.getElementById('world-etc'));

      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start', inline:'nearest' });
      }
    },

    async getNationList() 
    {
      let nationList = await this.$api("/api/nationList_bus", {});
      this.nationList = nationList;
      
      let natName = nationList.filter((item) => {
        return item.baseCode == this.nt
      })
      //this.natName = natName[0].codeNameKor
      this.natName = natName.codeNameKor
      //console.log("nationList:",this.nationList,",natName:",this.natName)
    },

    //선택가능한 버스투어 지역정보
    async getBustourArea() {
      let bustourArea = await this.$api("/api/getBustourArea_new", { param: [ "L" ]})
      let bustourArea_etc = await this.$api("/api/getBustourArea_etc", {param: [ "L" ]})

      let ntToAr = {}

      if(bustourArea.length > 0)
      {
        this.bustourArea = bustourArea
        //국가별 지역으로 정리
        bustourArea.forEach(item => {
          if(!ntToAr[item.ntCd])
          {
            ntToAr[item.ntCd] = [];
          }
          ntToAr[item.ntCd].push({
            ntCd: item.ntCd,
            arCd: item.arCd,
            NT: item.NT,
            AR: item.AR
          })
        })
      }
      this.ntToAr_jp = ntToAr

      let ntToAr_etc = {}

      if(bustourArea_etc.length > 0)
      {
        this.bustourArea_etc = bustourArea_etc
        //국가별 지역으로 정리
        bustourArea_etc.forEach(item => {
          if(!ntToAr_etc[item.ntCd])
          {
            ntToAr_etc[item.ntCd] = [];
          }
          ntToAr_etc[item.ntCd].push({
            ntCd: item.ntCd,
            arCd: item.arCd,
            NT: item.NT,
            AR: item.AR
          })
        })
      }
      this.ntToAr_etc = ntToAr_etc
    },


    // mixins에 있는 공통함수 호출샘플
    /** 자릿수 표시 */
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    /** 개행처리 */
    getStringFormat(text) {
      return this.$stringFormat(text);
    },
		/** 일자처리 */
    getDateFormat(date)
    {
      return this.$dateFormat(date);
    },

    // 신가격정책이 적용된 상품리스트
    async getProductList_new() 
    {
      let ntCd = this.nt
      let arCd = this.ar
      //let sRoute = "L";
      // let sMinPrice = 0;
      // let sMargin = 0;

      //console.log("ntCd:",ntCd,"arCd:",arCd);

      // 전체로컬상품추출 후, 연계상품제외
      //let productListForSales_tmptmp = await this.$api("/api/product_localtour_m", {param: [sRoute]});
      let productListForSales_tmptmp = await this.$api("/api/product_localtour_m_new", {});
      let productListForSales_tmp_notAsso = productListForSales_tmptmp.filter((item) => {
        return (item.assoFlag == null || item.assoFlag == "" || item.assoFlag == undefined)
      })

      // 판매카테고리에 현지투어가 있는 상품리스트
      let productListForSales_tmp = productListForSales_tmp_notAsso.filter((item) => {
        return item.pdtCate && item.pdtCate.includes('L')
      })      
      
      if(productListForSales_tmp.length > 0) 
      {
        this.productListForSales_org = productListForSales_tmp    //로컬전체상품(org)
      }
      
      // console.log("productListForSales_org: ", this.productListForSales_org)

			//엔데크 or 엔데이 모두 가능
			if(this.sellerCode === 'ND')
			{
				let productListForSales_ndaytrip1 = this.productListForSales_org.filter((item) => 
				{
					return item.sellerCode_nd == "Y" || item.sellerCode_nt == "Y";
				});

        let productListForSales_ndaytrip = productListForSales_ndaytrip1.sort((a, b) => {
          if (a.ntCd == 'JP' && b.ntCd != 'JP') 
          {
            return -1;
          } 
          else if (a.ntCd != 'JP' && b.ntCd === 'JP') 
          {
            return 1;
          } 
          else if (a.ntCd < b.ntCd) 
          {
            return -1;
          } 
          else if (a.ntCd > b.ntCd) 
          {
            return 1;
          } 
          else 
          {
            return 0;
          }
        });
        
				this.productListForSales = productListForSales_ndaytrip;
        //console.log("productListForSales: ", this.productListForSales )

        //일본내 상품
        let ndaytirpList_jp = this.productListForSales.filter(item => {
          return item.ntCd == 'JP'
        })
        //console.log("ndaytirpList_jp:",ndaytirpList_jp)
        //일본외 상품
        //let ndaytirpList_etc = [];
        let ndaytirpList_etc = this.productListForSales.filter(item => {
          return item.ntCd != 'JP'
        })
        //console.log("ndaytirpList_etc: ", ndaytirpList_etc)
        
        this.ndaytirpList_jp_org = ndaytirpList_jp.slice(0,6)
        this.ndaytirpList_jp_more = ndaytirpList_jp

        this.ndaytirpList_etc_org = ndaytirpList_etc.slice(0,6)
        this.ndaytirpList_etc_more = ndaytirpList_etc

        
        //엔데트 전체상품
        if((ntCd == "%" || ntCd == ""))
        {
          this.ndaytirpList_jp = ndaytirpList_jp.slice(0,6)
          this.ndaytirpList_etc = ndaytirpList_etc.slice(0,6)
          return; //이후 조건에 따라 값이 배열값이 덮어써지는 것을 막는다
        }

        //일본선택
        if((ntCd == "JP" && arCd == ""))    //일본전역
        {
          this.ndaytirpList_jp = ndaytirpList_jp.slice(0,6)
          this.ndaytirpList_etc = ndaytirpList_etc.slice(0,6)
        }      
        else if(ntCd == "JP" && arCd != "")   //일본내 특정
        {
          ndaytirpList_jp = this.productListForSales.filter(item => {
            return (item.ntCd === 'JP' && item.arCd == arCd)
          })

          this.ndaytirpList_jp = ndaytirpList_jp.slice(0,6)
          this.ndaytirpList_etc = ndaytirpList_etc.slice(0,6)
        }

        //일본외 선택
        if((ntCd != "JP" && arCd == ""))    //일본외 국가
        {
          ndaytirpList_etc = this.productListForSales.filter(item => {
            return (item.ntCd == ntCd)
          })

          this.ndaytirpList_jp = ndaytirpList_jp.slice(0,6)
          this.ndaytirpList_etc = ndaytirpList_etc.slice(0,6)
        }      
        else if(ntCd != "JP" && arCd != "")   //지역특정
        {
          ndaytirpList_etc = this.productListForSales.filter(item => {
            return (item.ntCd == ntCd && item.arCd == arCd)
          })

          this.ndaytirpList_jp = ndaytirpList_jp.slice(0,6)
          this.ndaytirpList_etc = ndaytirpList_etc.slice(0,6)
        }

        //dom요소가 모두 로드된 후 펑션호출
        this.$nextTick(() => {
          this.scrollToSection(this.nt);
        });
			}
    },

    // 상품문의
    inquiryProduct(pCode, sRoute) {
      this.$router.push({path: '/inquiryProduct', query: {productId: pCode, salesRoute:sRoute}});
    },


    //일본내 상품 더보기처리
    showJpMoreList() {
      this.jp_more = (this.jp_more === 'Y') ? "N" : "Y"
      if(this.jp_more === "N")
      {
        this.ndaytirpList_jp = this.ndaytirpList_jp_org
      }
      else
      {
        this.ndaytirpList_jp = this.ndaytirpList_jp_more
      }
    },

    showJpSelArea(param) {
      if(param === 'jpAll') 
      {
        document.querySelector('.more-jp').style.display = 'block'
        document.querySelector('.more-jp').classList.add('initial-state');
        this.ndaytirpList_jp = this.ndaytirpList_jp_more
      }
      else
      {
        document.querySelector('.more-jp').style.display = "none"
        this.ndaytirpList_jp = this.ndaytirpList_jp_more.filter(item => {
          return item.arCd === param
        })
      }
    },

    //일본외 상품 더보기 처리
    showEtcMoreList() {
      this.etc_more = (this.etc_more === 'Y') ? "N" : "Y"
      if(this.etc_more === "N")
      {
        this.ndaytirpList_etc = this.ndaytirpList_etc_org
      }
      else
      {
        this.ndaytirpList_etc = this.ndaytirpList_etc_more
      }      
    },    

    showEtcSelArea(param) {
      if(param === 'etcAll') 
      {
        document.querySelector('.more-etc').style.display = 'block'
        document.querySelector('.more-etc').classList.add('initial-state');
        this.ndaytirpList_etc = this.ndaytirpList_etc_more
      }
      else
      {
        document.querySelector('.more-etc').style.display = "none"
        this.ndaytirpList_etc = this.ndaytirpList_etc_more.filter(item => {
          return item.ntCd === param
        })
      }
    },

    goToDetail(productId, salesRoute) {
      this.$router.push({path: '/detail', query: {productId: productId, salesRoute:salesRoute}});
    },
    // 숫자콤마표시
    // getCurrencyFormat(value) {
    //   // console.log('value' + value)
    //   return (value+"").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap');
 
 /* ================================================
   # CSS 변수 — #sub 하위 전체 상속, 타 페이지 영향 없음
 ================================================ */
 #sub {
   --ci-green: #86cd53;
   --ci-green-dark: #6ab53e;
   --ci-green-light: #e8f7dc;
   --charcoal: #1c1c1c;
   --gray-100: #f8f9f5;
   --gray-200: #ededea;
   --gray-400: #aaa;
   --gray-600: #666;
   --text-main: #1c1c1c;
   --text-sub: #555;
   --radius-sm: 6px;
   --radius-md: 12px;
   --shadow-sm: 0 2px 8px rgba(0,0,0,0.07);
   --shadow-md: 0 6px 24px rgba(0,0,0,0.11);
   background-color: #fdfdfc;
 }
  
 @media (min-width: 991px) {
   #sub { margin-top: -6rem; }
 }
  
 .fingerPointer { cursor: pointer; }
  
  
 /* ================================================
   # 히어로 캐러셀
 ================================================ */
 .hero-img {
   width: 100%;
   height: 30rem;
   object-fit: cover;
 }
 .hero-img-pc {
   height: 50rem;
 }
  
 /* 인디케이터 */
 #sub .carousel-indicators .active { width: 40px; border-radius: 2px; }
 #sub .carousel-indicators [data-bs-target] {
   width: 20px;
   height: 3px;
   border-radius: 2px;
   background: rgba(255,255,255,0.6);
   border: none;
   opacity: 1;
   transition: all 0.3s;
 }
 #sub .carousel-indicators .active { background: var(--ci-green); }
  
 /* 화살표 투명 */
 #sub .carousel-control-prev,
 #sub .carousel-control-next { opacity: 0; }
  
 /* 캡션 */
 .hero-caption {
   bottom: 0 !important;
   left: 0 !important;
   right: 0 !important;
   padding: 0 !important;
   text-align: left;
   background: linear-gradient(to top, rgba(0,0,0,0.72) 0%, transparent 100%);
 }
 .caption-inner {
   padding: 2.5rem 4rem 3.5rem;
 }
 .caption-tag {
   display: inline-block;
   font-size: 0.9rem;
   font-weight: 700;
   letter-spacing: 3px;
   /* color: var(--ci-green); */
   color: gold;
   margin-bottom: 0.6rem;
   text-transform: uppercase;
 }
 .hero-caption h5 {
   font-family: 'Black Han Sans', sans-serif;
   font-size: 2.8rem;
   color: #fff;
   margin-bottom: 0.4rem;
   line-height: 1.2;
   text-shadow: 0 2px 12px rgba(0,0,0,0.3);
 }
 .hero-caption p {
   font-size: 1.05rem;
   color: rgba(255,255,255,0.85);
   margin: 0;
 }
  
 @media (max-width: 767px) {
   .caption-inner { padding: 1.5rem 1.5rem 2.5rem; }
   .hero-caption h5 { font-size: 1.4rem; }
   .hero-caption p { font-size: 0.88rem; }
   .caption-tag { font-size: 0.65rem; }
 }
  
  
 /* ================================================
   # 섹션 공통
 ================================================ */
 .packages {
   margin: 5rem 0;
 }
 .packages-etc {
   background: var(--gray-100);
   padding: 4rem 0;
   margin: 0;
 }
  
 /* 섹션 타이틀 */
 #sub .sub-title {
   margin-bottom: 2rem;
   padding-top: 0.5rem;
 }
 .title-accent-line {
   width: 40px;
   height: 4px;
   background: var(--ci-green);
   border-radius: 2px;
   margin-bottom: 0.8rem;
 }
 #sub .sub-title .st-main {
   display: block;
   color: var(--charcoal);
   font-size: 1.9rem;
   font-weight: 700;
   letter-spacing: -0.5px;
   margin-bottom: 0.3rem;
 }
 #sub .sub-title .st-sub {
   display: block;
   font-size: 0.9rem;
   color: var(--gray-600);
 }
  
 @media (max-width: 767px) {
   #sub .sub-title .st-main { font-size: 1.55rem; }
 }
  
  
 /* ================================================
   # 카테고리 필터
 ================================================ */
 #sub .category {
   margin: 0 0 2rem;
 }
 #sub .category ul {
   padding-left: 0;
   display: flex;
   flex-wrap: wrap;
   gap: 8px;
   list-style: none;
   margin: 0;
 }
 #sub .category ul li {
   padding: 7px 20px;
   border: 1.5px solid var(--gray-200);
   border-radius: 50px;
   background: #fff;
   transition: all 0.25s ease;
   cursor: pointer;
 }
 #sub .category ul li a {
   font-size: 0.88rem;
   font-weight: 600;
   color: var(--gray-600);
   text-decoration: none;
   transition: color 0.2s;
 }
 #sub .category ul li:hover {
   background: var(--charcoal);
   border-color: var(--charcoal);
 }
 #sub .category ul li:hover a {
   color: #fff;
 }
  
 @media (max-width: 1024px) {
   #sub .category ul li { padding: 5px 14px; }
   #sub .category ul li a { font-size: 0.82rem; }
 }
  
  
 /* ================================================
   # 상품 카드
 ================================================ */
 #sub .packages .package-item {
   border-radius: var(--radius-md);
   overflow: hidden;
   background: #fff;
   box-shadow: var(--shadow-sm);
   transition: transform 0.3s ease, box-shadow 0.3s ease;
 }
 #sub .packages .package-item:hover {
   transform: translateY(-4px);
   box-shadow: var(--shadow-md);
 }
  
 @media (max-width: 991px) {
   #sub .packages .package-item { margin-bottom: 1.5rem; }
 }
  
 /* 이미지 영역 */
 #sub .package-item .pic {
   position: relative;
   overflow: hidden;
 }
 /* ★ 고정 높이(280px) 대신 4:3 비율 유지 → 열 폭이 달라져도 왜곡/과도한 크롭 없음 */
 #sub .package-item .card-img-top {
   width: 100%;
   aspect-ratio: 4 / 3;
   object-fit: cover;
   transition: transform 0.4s ease;
   display: block;
 }
 #sub .package-item:hover .card-img-top {
   transform: scale(1.04);
 }
  
 /* 호버 오버레이 */
 #sub .package-item .pic .packages-hover {
   display: flex;
   position: absolute;
   width: 100%;
   height: 100%;
   background: rgba(28, 28, 28, 0.5);
   align-items: center;
   justify-content: center;
   opacity: 0;
   transition: opacity 0.35s ease;
   top: 0;
   left: 0;
 }
 #sub .package-item:hover .pic .packages-hover {
   opacity: 1;
 }
 .hover-cta {
   color: #fff;
   font-size: 0.9rem;
   font-weight: 700;
   letter-spacing: 1px;
   border: 2px solid var(--ci-green);
   padding: 8px 20px;
   border-radius: 30px;
   background: rgba(134, 205, 83, 0.15);
   transition: background 0.2s;
 }
 .hover-cta:hover { background: var(--ci-green); }
  
 /* 텍스트 영역 */
 #sub .package-item-txt {
   padding: 1rem 1.2rem 1.2rem;
 }
  
 .pdtName {
   height: 3.6rem;
   display: -webkit-box;
   -webkit-line-clamp: 2;
   -webkit-box-orient: vertical;
   overflow: hidden;
   text-overflow: ellipsis;
   line-height: 1.45;
   font-size: 1.05rem;
   font-weight: 700;
   color: var(--charcoal);
   margin-bottom: 0.4rem;
 }
 .pdtRemarks {
   font-size: 0.82rem;
   color: var(--gray-600);
   /* ★ line-height(1.4) × 2줄 = 2.8em. em 단위라 폰트 크기가 바뀌어도 항상 정확히 2줄 높이 확보 */
   min-height: 2.8em;
   display: -webkit-box;
   -webkit-line-clamp: 2;
   line-clamp: 2;
   -webkit-box-orient: vertical;
   overflow: hidden;
   text-overflow: ellipsis;
   line-height: 1.4;
   margin-bottom: 0;
 }
 .pdtRemarks i { color: var(--ci-green-dark); margin-right: 3px; }
  
 .card-divider {
   height: 1px;
   background: var(--gray-200);
   margin: 0.8rem 0;
 }
  
 /* 가격 */
 #sub .packages-content .price { float: none; }
 .price-row { align-items: baseline; }
 .ndayPrice { color: var(--charcoal); }
 .price-won { font-size: 0.88rem; color: var(--gray-600); margin-left: 2px; }
 .original-price { font-size: 0.88rem !important; }
 .discount-rate {
   font-size: 1rem !important;
   font-weight: 800 !important;
   color: #e74c3c !important;
 }
 .final-price { color: var(--charcoal) !important; }
 .preparing-wrap { gap: 6px; }
 .preparing-text {
   font-size: 0.9rem !important;
   font-weight: 600;
   color: var(--gray-600);
 }
 .mbus-icon { width: 1.8rem !important; height: auto !important; }
  
  
 /* ================================================
   # 뱃지
 ================================================ */
 #sub .badge { text-align: center; }
 #sub .badge .badge1 {
   position: absolute;
   top: 0;
   left: 0;
   background: #e74c3c;
   opacity: 0.88;
   padding: 10px 14px;
   width: 150px;
   border-radius: 0 0 var(--radius-sm) 0;
 }
 #sub .badge .badge1 .badge1-text {
   color: #fff;
   font-size: 1rem;
   font-weight: 700;
   padding: 0;
 }
 #sub .badge .badge2 {
   position: absolute;
   top: 0;
   left: 0;
   background: rgba(255,255,255,0.9);
   opacity: 0.92;
   padding: 10px 14px;
   width: 150px;
   border-radius: 0 0 var(--radius-sm) 0;
 }
 #sub .badge .badge2 .badge2-text {
   color: var(--charcoal);
   font-size: 1rem;
   font-weight: 700;
   padding: 0;
 }
  
  
 /* ================================================
   # 더보기 버튼
 ================================================ */
 .more-wrap {
   display: flex;
   justify-content: center;
   margin: 2.5rem 0 1rem;
 }
 .more-btn {
   display: inline-flex;
   align-items: center;
   gap: 6px;
   padding: 11px 36px;
   border: 1.5px solid var(--charcoal);
   border-radius: 50px;
   font-size: 0.9rem;
   font-weight: 700;
   color: var(--charcoal);
   cursor: pointer;
   transition: all 0.25s ease;
   background: #fff;
 }
 .more-btn:hover {
   background: var(--charcoal);
   color: var(--ci-green);
 }


 /* ================================================
   # ★ lg 이상 3열 레이아웃 보정 (카드 폭이 좁아진 만큼 비율에 맞게 축소)
   #   - 반드시 위쪽 원본 규칙들보다 뒤에 위치해야 override 됨
 ================================================ */
 @media (min-width: 992px) {
   #sub .package-item-txt { padding: 0.85rem 1rem 1rem; }
   .pdtName { font-size: 0.95rem; }
   .pdtRemarks { font-size: 0.76rem; }

   /* bootstrap fs-4 는 !important 이므로 여기도 !important 필요 */
   #sub .ndayPrice.fs-4 { font-size: 1.2rem !important; }

   /* 뱃지: 원본 선택자와 동일한 specificity 로 작성해야 적용됨 */
   #sub .badge .badge1,
   #sub .badge .badge2 {
     width: 120px;
     padding: 8px 10px;
   }
   #sub .badge .badge1 .badge1-text,
   #sub .badge .badge2 .badge2-text {
     font-size: 0.85rem;
   }
   /* 뱃지가 2개일 때 간격 (템플릿의 인라인 margin-left:180px 덮어쓰기) */
   #sub .badge .badge2[style] { margin-left: 130px !important; }
 }
 </style>